webpackJsonp([223874747010974],{

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(78);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DonateButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DonateRow = function DonateRow(_ref) {
		var image = _ref.image;
		return _react2.default.createElement(
			DonateRowContainer,
			null,
			_react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					DonateRowTitle,
					null,
					"Donate"
				),
				_react2.default.createElement(
					DonateRowSubtitle,
					null,
					"Help Us Help Others"
				),
				_react2.default.createElement(
					DonateRowTagline,
					null,
					"Helping, healing and supporting women in crisis takes many hands. Donate today and bring hope."
				),
				_react2.default.createElement(
					DonateButton,
					{ to: "/donate" },
					"Donate"
				)
			),
			_react2.default.createElement(DonateFlower, { sizes: image.childImageSharp.sizes })
		);
	};
	
	var DonateRowContainer = _styledComponents2.default.div.withConfig({
		displayName: "DonateRow__DonateRowContainer"
	})(["padding:", "vw ", "vw;display:flex;overflow:hidden;height:", "vw;min-height:350px;box-sizing:border-box;@media screen and (max-width:768px){position:relative;.gatsby-image-outer-wrapper{position:absolute !important;right:0;bottom:0;overflow-x:hidden;}}@media screen and (max-width:600px){height:auto;.gatsby-image-outer-wrapper{transform:rotate(90deg);}}"], 100 / 24 * 1.5, 100 / 24 * 3, 100 / 24 * 6.5);
	
	var DonateFlower = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
		displayName: "DonateRow__DonateFlower"
	})(["width:", "vw;transform:translateY(-15%) translateX(20%);@media screen and (max-width:768px){transform:translateY(15%) translateX(30%);}@media screen and (max-width:600px){transform:translateY(15%) translateX(40%);}"], 100 / 24 * 11);
	
	var DonateRowTitle = _styledComponents2.default.h1.withConfig({
		displayName: "DonateRow__DonateRowTitle"
	})(["color:#0e4749;margin:0;font-weight:bold;font-size:4rem;"]);
	
	var DonateRowSubtitle = _styledComponents2.default.span.withConfig({
		displayName: "DonateRow__DonateRowSubtitle"
	})(["color:#05a143;text-transform:uppercase;font-weight:bold;line-height:1.5;letter-spacing:0.25rem;"]);
	
	var DonateRowTagline = _styledComponents2.default.h4.withConfig({
		displayName: "DonateRow__DonateRowTagline"
	})(["color:#728c8f;width:", "vw;font-weight:normal;margin:1rem 0;margin-bottom:3rem;line-height:1.333;@media screen and (max-width:768px){width:75%;}@media screen and (max-width:600px){width:100%;}"], 100 / 24 * 8);
	
	var DonateButton = exports.DonateButton = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
		displayName: "DonateRow__DonateButton"
	})(["color:white;background:linear-gradient(45deg,#136163,#05a143);padding:1rem 4rem;border-radius:10px;font-size:1.333rem;text-transform:uppercase;font-weight:bold;box-shadow:0 5px 10px rgba(4,135,56,0.3);transition:300ms;&:hover{box-shadow:0 10px 20px rgba(4,135,56,0.3);transform:translateY(-0.5rem);}@media screen and (max-width:1024px){padding:0.75rem 2rem;font-size:1rem;}"]);
	
	exports.default = DonateRow;

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _exenv = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (_exenv.canUseDOM) {
		var $script = __webpack_require__(1307);
		$script("https://tithe.ly/widget/v3/give.js?3", "tithely-embed");
	}
	
	var Tithely = function (_Component) {
		_inherits(Tithely, _Component);
	
		function Tithely() {
			_classCallCheck(this, Tithely);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Tithely.prototype.componentDidMount = function componentDidMount() {
			if (_exenv.canUseDOM) {
				var _$script = __webpack_require__(1307);
				_$script.ready("tithely-embed", function () {
					var tw = create_tithely_widget();
				});
			}
		};
	
		Tithely.prototype.render = function render() {
			return _react2.default.createElement(
				TithelyButton,
				{ className: "tithely-give-btn", "data-church-id": "367990" },
				"Donate Online"
			);
		};
	
		return Tithely;
	}(_react.Component);
	
	exports.default = Tithely;
	
	
	var TithelyButton = _styledComponents2.default.button.withConfig({
		displayName: "Tithely__TithelyButton"
	})(["color:white;background:linear-gradient(45deg,#136163,#05a143);padding:1rem 4rem;border-radius:10px;font-size:1.2rem;text-transform:uppercase;font-weight:bold;box-shadow:0 5px 10px rgba(4,135,56,0.3);transition:300ms;outline:none;cursor:pointer;&:hover{box-shadow:0 10px 20px rgba(4,135,56,0.3);transform:translateY(-0.5rem);}@media screen and (max-width:1024px){padding:0.75rem 2rem;font-size:1rem;}"]);
	module.exports = exports["default"];

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.donatePageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\tborder-bottom: 5px solid ", ";\n\tpadding-top: ", "vw;\n\tpadding-right: ", "vw;\n\n\t@media screen and (max-width: 800px) {\n\t\tflex-wrap: wrap;\n\t\th3 {\n\t\t\tfont-size: 1.25rem !important;\n\t\t}\n\t}\n"], ["\n\tborder-bottom: 5px solid ", ";\n\tpadding-top: ", "vw;\n\tpadding-right: ", "vw;\n\n\t@media screen and (max-width: 800px) {\n\t\tflex-wrap: wrap;\n\t\th3 {\n\t\t\tfont-size: 1.25rem !important;\n\t\t}\n\t}\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledFlexComponent = __webpack_require__(23);
	
	var _styledFlexComponent2 = _interopRequireDefault(_styledFlexComponent);
	
	var _Typography = __webpack_require__(18);
	
	var _Tithely = __webpack_require__(1325);
	
	var _Tithely2 = _interopRequireDefault(_Tithely);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(422);
	
	var _DonateRow = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonatePage = function (_Component) {
		_inherits(DonatePage, _Component);
	
		function DonatePage() {
			_classCallCheck(this, DonatePage);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		DonatePage.prototype.render = function render() {
			var post = this.props.data.markdownRemark;
	
			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(_reactHelmet2.default, { title: "Donate" }),
				_react2.default.createElement(
					DonateContainer,
					null,
					_react2.default.createElement(
						DonateTitleContainer,
						null,
						_react2.default.createElement(
							_Typography.Title,
							{ lineheight: "0" },
							post.frontmatter.title
						),
						_react2.default.createElement(
							_Typography.SubTitle,
							null,
							"Sponsor a Transformation Today!"
						)
					),
					_react2.default.createElement(
						DonatePercentContainer,
						{ inline: true, alignCenter: true },
						_react2.default.createElement(
							DonatePercentage,
							null,
							"100%"
						),
						_react2.default.createElement(
							"h3",
							null,
							"of the funds given go towards",
							_react2.default.createElement("br", null),
							"supporting our work."
						)
					),
					_react2.default.createElement(
						PercentageTagline,
						null,
						"At Narrow Road Home, we believe in the power of partnership. We rely on the generous support of benefactors to continue our mission of healing."
					),
					_react2.default.createElement(
						FundsContainer,
						null,
						_react2.default.createElement(
							FundsTitle,
							null,
							"Where Do Funds Go?"
						),
						_react2.default.createElement(
							FundsList,
							null,
							_react2.default.createElement(
								FundsListItem,
								null,
								_react2.default.createElement(
									"h6",
									null,
									"Groceries & House Supplies"
								),
								_react2.default.createElement(
									"i",
									null,
									"Support the Narrow Road Home with daily costs to assist women on their recovery journey."
								)
							),
							_react2.default.createElement(
								FundsListItem,
								null,
								_react2.default.createElement(
									"h6",
									null,
									"Assisting Women with Recovery Costs"
								),
								_react2.default.createElement(
									"i",
									null,
									"The cost to house and assist women in their journey is constantly evolving. We try our best to help women regardless of their financial situation, and rely on your help to do so."
								)
							),
							_react2.default.createElement(
								FundsListItem,
								null,
								_react2.default.createElement(
									"h6",
									null,
									"Narrow Road Home Growth Fund"
								),
								_react2.default.createElement(
									"i",
									null,
									"This fund allows us to further our reach to connect with women who need help."
								)
							)
						)
					),
					_react2.default.createElement(
						DonateButtonContainer,
						null,
						_react2.default.createElement(_Tithely2.default, null)
					),
					_react2.default.createElement(
						DonateButtonContainer,
						null,
						_react2.default.createElement(
							_gatsbyPluginGoogleAnalytics.OutboundLink,
							{
								target: "_blank",
								style: { color: "white" },
								href: "https://gcfcanada.com/narrow-road-home-project/" },
							_react2.default.createElement(
								DonateButton,
								null,
								"Alternate Donation*",
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"small",
									null,
									"with the Great Commission Foundation"
								)
							)
						)
					),
					_react2.default.createElement(
						DonateDetailsContainer,
						null,
						"*Donations can be made though 'The Great Commission Foundation' and are applicable for tax receipts. This button will redirect you to The Great Commission Foundation's website. Under the field 'designation' please select 'narrow road home' from the dropdown menu. Thank you for your support and partnership!"
					)
				)
			);
		};
	
		return DonatePage;
	}(_react.Component);
	
	DonatePage.propTypes = {
		data: _propTypes2.default.shape({
			markdownRemark: _propTypes2.default.shape({
				frontmatter: _propTypes2.default.shape({
					title: _propTypes2.default.string
				})
			})
		})
	};
	exports.default = DonatePage;
	
	
	var DonateDetailsContainer = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__DonateDetailsContainer"
	})(["padding:0 ", "vw ", "vw 0;"], 100 / 24, 100 / 24);
	
	var DonateButton = _styledComponents2.default.span.withConfig({
		displayName: "donate-page__DonateButton"
	})(["background:", ";padding:1rem 2rem;font-size:1rem;font-weight:500;text-transform:uppercase;display:inline-block;border-radius:10px;color:black;transition:", ";small{font-weight:lighter;font-size:0.8rem !important;}&:hover{background:", ";}"], function (props) {
		return props.theme.color.lightGray;
	}, function (props) {
		return props.theme.animation.normal;
	}, function (props) {
		return props.theme.color.gray;
	});
	
	var DonateButtonContainer = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__DonateButtonContainer"
	})(["margin-top:", "vw;margin-bottom:", "vw;@media screen and (max-width:800px){margin:", "vw 0;}"], 100 / 24, 100 / 24 / 2, 100 / 24 * 3);
	
	var DonateContainer = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__DonateContainer"
	})(["padding-left:", "vw;"], 100 / 24 * 3);
	
	var DonateTitleContainer = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__DonateTitleContainer"
	})(["margin-top:", "vw;@media screen and (max-width:800px){margin-top:", "vw;", "{max-width:100%;}", "{font-size:1.25rem !important;max-width:80%;}}"], 100 / 24 * 2, 100 / 24 * 4, _Typography.Title, _Typography.SubTitle);
	
	var DonatePercentContainer = _styledFlexComponent2.default.extend(_templateObject, function (props) {
		return props.theme.color.green;
	}, 100 / 24 / 2, 100 / 24 * 1.5);
	
	var DonatePercentage = _styledComponents2.default.span.withConfig({
		displayName: "donate-page__DonatePercentage"
	})(["font-size:4.44rem;font-weight:bold;margin-right:2rem;color:", ";@media screen and (max-width:800px){font-size:3rem;}"], function (props) {
		return props.theme.color.green;
	});
	
	var PercentageTagline = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__PercentageTagline"
	})(["margin-top:1rem;max-width:740px;font-weight:500;@media screen and (max-width:800px){max-width:80%;}"]);
	
	var FundsContainer = _styledComponents2.default.div.withConfig({
		displayName: "donate-page__FundsContainer"
	})(["@media screen and (max-width:800px){margin-top:", "vw;}"], 100 / 24 * 3);
	
	var FundsTitle = _styledComponents2.default.h1.withConfig({
		displayName: "donate-page__FundsTitle"
	})(["margin-top:", "vw;font-weight:normal;padding-left:2rem;color:", ";border-left:solid 5px ", ";@media screen and (max-width:800px){font-size:1.5rem !important;border:none;padding-left:0;}"], 100 / 24 * 1, function (props) {
		return props.theme.color.darkGreen;
	}, function (props) {
		return props.theme.color.darkGreen;
	});
	
	var FundsList = _styledComponents2.default.ol.withConfig({
		displayName: "donate-page__FundsList"
	})(["list-style-type:none;margin-left:0;padding-left:0;"]);
	
	var FundsListItem = _styledComponents2.default.li.withConfig({
		displayName: "donate-page__FundsListItem"
	})(["counter-increment:fundslistcounter;margin:1rem 0;max-width:", "vw;@media screen and (max-width:800px){max-width:80%;}h6{font-size:1.5rem;display:inline;color:", ";@media screen and (max-width:800px){font-size:1.25rem;}}i{font-size:1rem;line-height:1.35;display:block;color:", ";@media screen and (max-width:800px){}}&:first-child{counter-reset:fundslistcounter;}&::before{content:counter(fundslistcounter) \" \";font-weight:bold;color:", ";display:inline-block;width:2rem;font-size:2rem;opacity:0.85;@media screen and (max-width:800px){font-size:1.5rem;}}"], 100 / 24 * 10, function (props) {
		return props.theme.color.darkTeal;
	}, function (props) {
		return props.theme.color.darkGray;
	}, function (props) {
		return props.theme.color.darkTeal;
	});
	
	var donatePageQuery = exports.donatePageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-donate-page-jsx-b96352f28f23d3201d4e.js